import { IconButton } from "@mui/material";
import { FC } from "react";
import { FaCommentDots } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import styled from "styled-components";
import { useChat } from "../../../hooks/useChat";

const HeaderWrapper = styled("div")`
  height: 40px;
  display: flex;
  justify-content: center;
  position: relative;
  color: ${(props) => props.theme.colors.secondary};

  &::after {
    content: "";
    display: block;
    position: absolute;
    height: 1px;
    width: 90%;
    bottom: 0;
    background-color: ${(props) => props.theme.colors.secondary};
  }
`;

const Title = styled("span")`
  display: inherit;
  align-items: center;
  gap: 10px;

  font-size: 1.2rem;
  line-height: 1.2;

  .svg {
    fill: ${(props) => props.theme.colors.secondary};
  }
`;

const CloseBtn = styled(IconButton)`
  && {
    position: absolute;
    right: 5px;
    top: 5px;
    display: flex;
    align-items: center;
    justify-self: center;

    height: 30px;
    width: 30px;
    min-width: fit-content;
    padding: 5px;
  }
`;

const ChatHeader: FC = () => {
  const { handleChatOpen } = useChat();

  return (
    <HeaderWrapper>
      <Title>
        Chat <FaCommentDots size={18} />
      </Title>
      <CloseBtn onClick={() => handleChatOpen(false)}>
        <MdClose size={22} />
      </CloseBtn>
    </HeaderWrapper>
  );
};

export default ChatHeader;
